module.exports = __webpack_public_path__ + "static/img/21.b884f76a.png";